<template>
  <!-- There's always 1 ticket (the current one), so only show a summary if there are other tickets. -->
  <div v-if="tickets.length > 1">
    <VSubheader class="px-0">Tickets</VSubheader>
    <ChipLabel
      v-for="status in statuses"
      v-bind="statusColors[status]"
      :key="status"
      small
    >
      {{ statusCounts[status] }} {{ statusLabel(status) }}
    </ChipLabel>
  </div>
</template>

<script lang="ts">
import { capitalize } from 'lodash-es'
import { defineComponent, PropType } from 'vue'

import ChipLabel from '@/components/ChipLabel.vue'
import { ticketStatusColors } from '@/components/mixins/tickets'
import {
  Ticket as RestTicket,
  TicketStatus
} from '@/store/modules/types/zendeskRest'

export default defineComponent({
  components: { ChipLabel },
  props: {
    tickets: {
      type: Array as PropType<RestTicket[]>,
      required: true
    }
  },
  setup({ tickets }) {
    const statusCounts = tickets.reduce(
      (counts, ticket) => {
        counts[ticket.status] = (counts[ticket.status] || 0) + 1
        return counts
      },
      {} as { [status: string]: number }
    )
    const statuses: TicketStatus[] = [
      'new',
      'open',
      'hold',
      'pending',
      'solved',
      'closed'
    ].filter((status) => statusCounts[status]) as TicketStatus[]
    return {
      statuses,
      statusColors: ticketStatusColors,
      statusCounts,
      /** Expands hold to On Hold, and capitalizes all other statuses. */
      statusLabel: (status: TicketStatus) =>
        (status === 'hold' ? 'On ' : '') + capitalize(status)
    }
  }
})
</script>
